export const formatNumberToDecimal = (num: number) =>
  new Intl.NumberFormat("ru-KZ", {
    style: "decimal"
  }).format(num);
